// extracted by mini-css-extract-plugin
module.exports = {"infoTextWrapper":"createQuestionnaire_infoTextWrapper__MOdxl","helpInfoText":"createQuestionnaire_helpInfoText__HsP9j"};